import { useTranslation } from 'react-i18next'
import { useTokenBalance } from '~/state/wallet/hooks'
import { useLimitSwapPair, useLimitSwapLimitPrice } from '~/state/dex/hooks'
import { BalanceLabel, MaxButtonWrapper, StyledMaxButton } from './styled'
import { useAppDispatch } from '~/state/hooks'
import { TradeDirection } from '~/components/Exchange/types'
import {
  updateLimitSwapAmount,
  updateLimitSwapPairAmount,
} from '~/state/dex/actions'
import BigNumber from 'bignumber.js'
import { useAccount } from 'wagmi'
import { formatFormAmount } from '~/utils/numbers'

const MaxButton: React.FC = () => {
  const { t } = useTranslation()
  const [inputToken, outputToken] = useLimitSwapPair()
  const { address: account } = useAccount()
  const dispatch = useAppDispatch()
  const limitPrice = useLimitSwapLimitPrice()

  const tokenBalance = useTokenBalance(inputToken)
  const balance = formatFormAmount(tokenBalance?.toDecimalsFixed(), 4) ?? '0'

  const showMax = new BigNumber(tokenBalance?.toDecimalsFixed()).gt(0)

  const onMaxClick = () => {
    const amount = new BigNumber(tokenBalance.toDecimalsFixed()).toFixed()

    if (limitPrice) {
      const calcOutputAmount = new BigNumber(amount)
        .times(limitPrice)
        .decimalPlaces(outputToken?.decimals)
        .toString()

      dispatch(
        updateLimitSwapPairAmount({
          inputAmount: amount,
          outputAmount: calcOutputAmount,
        }),
      )
      return
    }

    dispatch(
      updateLimitSwapAmount({
        direction: TradeDirection.Input,
        amount,
      }),
    )
  }

  if (!account) return null

  return (
    <MaxButtonWrapper>
      <BalanceLabel>
        {t('balance')}: {balance} {inputToken?.symbol}
      </BalanceLabel>
      {showMax ? (
        <StyledMaxButton onClick={onMaxClick}>MAX</StyledMaxButton>
      ) : null}
    </MaxButtonWrapper>
  )
}

export default MaxButton
